var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"base-spinner fa-3x"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }